<template>
  <div class="znsSend">
    <h2 class="mb-4">Gửi ZNS</h2>

    <!-- FILTER CARD -->
    <div class="card mb-4">
      <div class="card-header font-weight-bold">Bộ lọc khách hàng</div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-lg-3 col-md-6">
            <label>Trạng thái KH</label>
            <b-form-select v-model="filter.status" :options="statusOptions" />
          </div>
          <div class="col-lg-3 col-md-6">
            <label>Trạng thái task</label>
            <b-form-select v-model="filter.taskStatus" :options="taskStatusOptions" />
          </div>
          <div class="col-lg-3 col-md-6">
            <label>Trạng thái ZNS</label>
            <b-form-select v-model="filter.znsStatus" :options="znsStatusOptions" />
          </div>
          <div class="col-lg-3 col-md-6">
            <label>Loại khách</label>
            <b-form-select v-model="filter.customerType" :options="customerTypeOptions" />
          </div>
          <div class="col-lg-3 col-md-6">
            <label>Đơn hàng</label>
            <b-form-select v-model="filter.hasOrder" :options="hasOrderOptions" />
          </div>
          <div class="col-lg-3 col-md-6">
            <label>Từ ngày</label>
            <input type="date" class="form-control" v-model="filter.fromDate" />
          </div>
          <div class="col-lg-3 col-md-6">
            <label>Đến ngày</label>
            <input type="date" class="form-control" v-model="filter.toDate" />
          </div>
        </div>
        <div class="mt-4 d-flex" style="gap:10px">
          <b-button variant="primary" @click="submitFilter" :disabled="loading">
            <i class="fa fa-search mr-1"></i> Tìm khách hàng
          </b-button>
          <b-button variant="outline-success" @click="clearFilter">
            <i class="fa fa-refresh mr-1"></i> Đặt lại
          </b-button>
          <b-spinner small v-if="loading" />
        </div>
      </div>
    </div>

    <!-- SUMMARY + ACTION -->
    <div v-if="summary" class="card mb-4">
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex" style="gap: 24px">
              <div>
                <div class="text-muted small">Khách phù hợp</div>
                <div class="font-weight-bold" style="font-size: 22px">
                  {{ summary.matchedCount }}
                </div>
              </div>
              <div class="border-left pl-4">
                <div class="text-muted small">Sẽ gửi ZNS</div>
                <div class="font-weight-bold text-primary" style="font-size: 22px">
                  {{ summary.sendCount }}
                </div>
              </div>
              <div class="border-left pl-4">
                <div class="text-muted small">Giới hạn</div>
                <div class="font-weight-bold" style="font-size: 22px">
                  {{ summary.maxCount || "∞" }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right mt-3 mt-md-0">
            <b-button variant="success" :disabled="summary.sendCount === 0" @click="openSendModal">
              <i class="fa fa-paper-plane mr-2"></i> Gửi ZNS
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL GỬI ZNS (giữ nguyên) -->
    <b-modal ref="sendModal" title="Gửi ZNS">
      <p v-if="summary">
        Tìm thấy <b>{{ summary.matchedCount }}</b> khách phù hợp. Sẽ gửi tới
        <b>{{ summary.sendCount }}</b> khách.
      </p>
      <label>Số lượng gửi tối đa</label>
      <input type="number" class="form-control" v-model.number="maxCount" min="1" :max="summary?.sendCount" />
      <small class="text-muted">Để trống = gửi toàn bộ</small>
      <template #modal-footer>
        <b-button variant="secondary" @click="$refs.sendModal.hide()"> Hủy </b-button>
        <b-button variant="success" @click="submitBatch" :disabled="sending">
          <b-spinner small v-if="sending" /> Gửi
        </b-button>
      </template>
    </b-modal>

    <!-- DANH SÁCH BATCH ĐANG THEO DÕI (SSE) -->
   <div v-if="trackingBatches.length > 0" class="mt-4">
  <h5>Đang theo dõi tiến trình</h5>
  <div class="batch-list">
    <div v-for="batch in trackingBatches" :key="batch.id" class="batch-card">
      <div class="batch-title">
        Đợt gửi #{{ batch.data.id }}
        <span class="badge" :class="badgeClass(batch.data.status)">
          {{ batch.data.status }}
        </span>
        <button class="close-btn" @click="stopTracking(batch.id)" title="Dừng theo dõi">✕</button>
      </div>
      <div class="progress-wrap">
        <div class="progress-bar" :style="{ width: batch.data.progressPercent + '%' }"></div>
      </div>
      <div class="progress-text">
        {{ batch.data.progressPercent }}% ({{ batch.data.processedCount }}/{{ batch.data.totalCount }})
      </div>
      <div class="counters">
        Thành công: {{ batch.data.successCount }} | Thất bại: {{ batch.data.failCount }} | Lỗi: {{ batch.data.errorCount }}
      </div>
      <div class="started">Bắt đầu: {{ batch.data.startedAt || '-' }}</div>
      <div class="finished">Kết thúc: {{ batch.data.finishedAt || '-' }}</div>
    </div>
  </div>
  </div>
  </div>
</template>

<script>
import apiClient from "@/axios"

export default {
  data() {
    return {
      filter: {
        status: "",
        taskStatus: "",
        znsStatus: "not_sent",
        customerType: "",
        hasOrder: "",
        fromDate: "",
        toDate: "",
      },
      summary: null,
      batchRequestBody: null,
      loading: false,
      sending: false,
      maxCount: null,

      // Danh sách các batch đang theo dõi
      trackingBatches: [], // mỗi phần tử: { id, data, controller }

      statusOptions: [
        { value: "", text: "Tất cả" },
        { value: -1, text: "Tất cả (trừ deleted)" },
        { value: 0, text: "New" },
        { value: 1, text: "Accepted" },
        { value: 2, text: "Rejected" },
        { value: 3, text: "No Answer" },
        { value: 4, text: "Not Catch" },
        { value: 5, text: "Consultation Needed" },
      ],
      taskStatusOptions: [
        { value: "", text: "Tất cả" },
        { value: "none", text: "Chưa giao task" },
        { value: "pending", text: "Đã giao, chưa xử lý" },
        { value: "completed", text: "Đã xử lý" },
      ],
      znsStatusOptions: [
        { value: "", text: "Tất cả" },
        { value: "not_sent", text: "Chưa gửi" },
        { value: "failed", text: "Gửi thất bại" },
        { value: "success", text: "Gửi thành công" },
      ],
      customerTypeOptions: [
        { value: "", text: "Tất cả" },
        { value: "new", text: "Khách mới" },
        { value: "ordered", text: "Đã đặt đơn" },
      ],
      hasOrderOptions: [
        { value: "", text: "Tất cả" },
        { value: "true", text: "Đã có đơn" },
        { value: "false", text: "Chưa có đơn" },
      ],
    }
  },

  methods: {
    buildFilter() {
      const f = {}
      if (this.filter.status !== "") f.status = Number(this.filter.status)
      if (this.filter.taskStatus) f.taskStatus = this.filter.taskStatus
      if (this.filter.znsStatus) f.znsStatus = this.filter.znsStatus
      if (this.filter.customerType) f.customerType = this.filter.customerType
      if (this.filter.hasOrder) f.hasOrder = this.filter.hasOrder
      if (this.filter.fromDate) f.fromDate = this.filter.fromDate
      if (this.filter.toDate) f.toDate = this.filter.toDate
      return f
    },

    async submitFilter() {
      this.loading = true
      try {
        const res = await apiClient.get("/api/v1/admin/customer/zns/send-batch/count", {
          params: this.buildFilter(),
        })
        this.summary = res.data
        this.batchRequestBody = res.data.batchRequestBody
      } catch {
        this.$bvToast.toast("Lỗi khi tìm khách hàng", { variant: "danger", solid: true })
      }
      this.loading = false
    },

    clearFilter() {
      this.filter = {
        status: "",
        taskStatus: "",
        znsStatus: "not_sent",
        customerType: "",
        hasOrder: "",
        fromDate: "",
        toDate: "",
      }
      this.summary = null
    },

    openSendModal() {
      this.maxCount = null
      this.$refs.sendModal.show()
    },

    async submitBatch() {
      if (!this.batchRequestBody) return
      this.sending = true
      try {
        const body = { ...this.batchRequestBody }
        if (this.maxCount !== null) body.maxCount = this.maxCount
        const res = await apiClient.post("/api/v1/admin/customer/zns/send-batch", body)
        this.$refs.sendModal.hide()
        this.$bvToast.toast(`Batch #${res.data.batchId} đã được tạo`, { variant: "success", solid: true })

        // Bắt đầu theo dõi batch vừa tạo (thêm vào danh sách)
        this.startTracking(res.data.batchId)
      } catch (error) {
        this.$bvToast.toast("Lỗi tạo batch: " + (error.response?.data?.message || error.message), { variant: "danger", solid: true })
      }
      this.sending = false
    },

    // --- SSE Tracking ---
    badgeClass(status) {
      const map = {
        QUEUED: "badge-queued",
        RUNNING: "badge-running",
        COMPLETED: "badge-completed",
        FAILED: "badge-failed",
        CANCELLED: "badge-cancelled",
      }
      return map[status] || "badge-secondary"
    },

    transformProgressPayload(payload) {
      return {
        id: payload.id,
        status: payload.status,
        totalCount: payload.totalCount ?? payload.total_count ?? 0,
        processedCount: payload.processedCount ?? payload.processed_count ?? 0,
        successCount: payload.successCount ?? payload.success_count ?? 0,
        failCount: payload.failCount ?? payload.fail_count ?? 0,
        errorCount: payload.errorCount ?? payload.error_count ?? 0,
        startedAt: payload.startedAt ?? payload.started_at,
        finishedAt: payload.finishedAt ?? payload.finished_at,
        progressPercent: payload.progressPercent ?? payload.progress_percent ?? 0,
        isDone: payload.isDone ?? payload.is_done ?? false,
      }
    },

    startTracking(batchId) {
      // Tạo dữ liệu mặc định
      const initialData = {
        id: batchId,
        status: "QUEUED",
        totalCount: 0,
        processedCount: 0,
        successCount: 0,
        failCount: 0,
        errorCount: 0,
        progressPercent: 0,
        startedAt: null,
        finishedAt: null,
        isDone: false,
      }

      // Tạo AbortController cho kết nối này
      const controller = new AbortController()

      // Thêm vào mảng trackingBatches
      this.trackingBatches.push({
        id: batchId,
        data: initialData,
        controller,
      })

      // Mở stream SSE
      this.openTrackingStream(batchId, controller)
    },

    async openTrackingStream(batchId, controller) {
      // Lấy token từ store
      let token = ''
      if (this.$store && this.$store.getters.jwt) {
        token = this.$store.getters.jwt
      } else {
        token = localStorage.getItem('access_token') || localStorage.getItem('token') || ''
      }

      if (!token) {
        this.$bvToast.toast('Không tìm thấy token xác thực.', { variant: 'danger' })
        controller.abort()
        this.removeBatchFromList(batchId)
        return
      }

      if (!token.startsWith('Bearer ')) {
        token = `Bearer ${token}`
      }

      const baseUrl = apiClient.defaults.baseURL.replace(/\/+$/, '')
      const url = `${baseUrl}/api/v1/admin/customer/zns/batches/${encodeURIComponent(batchId)}/progress/stream`

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Accept: 'text/event-stream',
            Authorization: token,
          },
          signal: controller.signal,
        })

        if (!response.ok) {
          const body = await response.text()
          throw new Error(`HTTP ${response.status}: ${body}`)
        }
        if (!response.body) {
          throw new Error('ReadableStream không được hỗ trợ.')
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        const sseState = { buffer: '' }

        while (true) {
          const { done, value } = await reader.read()
          if (done) break
          const chunk = decoder.decode(value, { stream: true })
          this.parseSSEChunk(sseState, chunk, (eventName, dataText) => {
            console.log(`SSE [${eventName}] batch ${batchId}:`, dataText)

            let payload
            try {
              payload = JSON.parse(dataText)
            } catch {
              payload = { raw: dataText }
            }

            if (payload && typeof payload === 'object') {
              const transformed = this.transformProgressPayload(payload)
              // Cập nhật dữ liệu trong mảng
              const batch = this.trackingBatches.find(b => b.id === batchId)
              if (batch) {
                batch.data = { ...batch.data, ...transformed }
              }
            }

            // Nếu batch kết thúc, có thể tự động xóa sau vài giây? Tạm thời giữ lại.
            if (eventName === 'done' || payload?.isDone || payload?.is_done) {
              // Có thể hiển thị thông báo và xóa sau 3s
              setTimeout(() => {
                this.removeBatchFromList(batchId)
              }, 3000)
            }
          })
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Lỗi SSE:', err)
          this.$bvToast.toast(`Lỗi kết nối batch #${batchId}: ${err.message}`, { variant: 'warning' })
          this.removeBatchFromList(batchId)
        }
      }
    },

    parseSSEChunk(state, chunkText, onEvent) {
      state.buffer += chunkText
      const events = state.buffer.split('\n\n')
      state.buffer = events.pop() || ''

      for (const rawEvent of events) {
        const lines = rawEvent.split(/\r?\n/)
        let eventName = 'message'
        const dataLines = []

        for (const line of lines) {
          if (!line || line.startsWith(':')) continue
          if (line.startsWith('event:')) {
            eventName = line.slice(6).trim()
          } else if (line.startsWith('data:')) {
            dataLines.push(line.slice(5).trim())
          }
        }

        if (dataLines.length > 0) {
          onEvent(eventName, dataLines.join('\n'))
        }
      }
    },

    stopTracking(batchId) {
      // Tìm batch trong mảng, hủy controller, xóa khỏi mảng
      const batch = this.trackingBatches.find(b => b.id === batchId)
      if (batch && batch.controller) {
        batch.controller.abort()
      }
      this.removeBatchFromList(batchId)
    },

    removeBatchFromList(batchId) {
      const index = this.trackingBatches.findIndex(b => b.id === batchId)
      if (index !== -1) {
        // Hủy controller nếu còn (phòng khi gọi trực tiếp)
        if (this.trackingBatches[index].controller) {
          this.trackingBatches[index].controller.abort()
        }
        this.trackingBatches.splice(index, 1)
      }
    },
  },
}
</script>

<style scoped>
.summary-card {
  background: #f7f7f7;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
}
.summary-card.primary {
  background: #e8f3ff;
}
.summary-title {
  font-size: 14px;
  color: #666;
}
.summary-value {
  font-size: 28px;
  font-weight: 600;
  margin-top: 5px;
}

/* Batch list styles */
.batch-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.batch-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  background: #fafafa;
  position: relative;
}
.batch-title {
  font-weight: 700;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.close-btn {
  margin-left: auto;
  background: transparent;
  border: none;
  color: #999;
  font-size: 16px;
  cursor: pointer;
  padding: 0 4px;
}
.close-btn:hover {
  color: #f00;
}
.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  color: #fff;
  vertical-align: middle;
}
.badge-queued {
  background: #6c757d;
}
.badge-running {
  background: #007bff;
}
.badge-completed {
  background: #28a745;
}
.badge-failed {
  background: #dc3545;
}
.badge-cancelled {
  background: #9a6b00;
}
.progress-wrap {
  height: 18px;
  border: 1px solid #aaa;
  border-radius: 999px;
  overflow: hidden;
  background: #eee;
  margin-bottom: 6px;
}
.progress-bar {
  height: 100%;
  width: 0%;
  background: linear-gradient(90deg, #1e9b43, #3ecf6d);
  transition: width 0.2s ease;
}
.progress-text,
.counters,
.started,
.finished {
  font-size: 13px;
  margin: 2px 0;
  color: #333;
}
</style>
